const SkeletonOfChatInput = () => {
    return (
        <>
            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[280px] mb-5"></div>
            <div className="h-8  bg-gray-200 dark:bg-gray-700 w-50"></div>
        </>
    );
}

export default SkeletonOfChatInput;